import api from '@pray/shared/utils/api';
import type { ListResponse } from '@pray/shared/utils/api/types/response';

import { buildDailyItemLocalesUrl } from './buildDailyItemLocalesUrl';
import type { DailyItemLocaleRef, DailyItemLocaleResponse } from './types';

export async function listDailyItemLocales(ref: DailyItemLocaleRef) {
  const response = await api.executeGetRequest<ListResponse<DailyItemLocaleResponse>>(buildDailyItemLocalesUrl(ref));

  return response;
}
